import type { TestContext, TestFunction } from 'yup';

import { parseFromHumanToIsoDate } from 'shared/lib/dates';

/**
 * 3ья и 4ая цифры серии паспорта соответствуют последним двум цифрам года выпуска бланка паспорта (отклонение на 1-3 года).
 * Пример: паспорт серии 45 04 выдан в 2004 году, а паспорт серии 37 11 выдан в 2011 году.
 * */
export const isPassportSeriesValid: TestFunction = async (value, testContext) => {
  const context = testContext.parent ? testContext : (testContext.options.context as TestContext);
  const date = String(context.parent.passportIssueDate);
  const passportSN = String(value).replace(/\D/g, '');
  if (passportSN.length !== 10) {
    return context.createError({ path: context.path, message: 'Укажите корректный номер' });
  }

  const passportDate = parseFromHumanToIsoDate(date);
  const passportYear = Number(passportSN.slice(2, 4));
  const possibleYears = [2000 + passportYear, 1900 + passportYear];
  const passportYearsOffset = 10;

  const isValid =
    passportDate &&
    possibleYears.some((possibleYear) => {
      const passportDateYear = passportDate.getFullYear();
      /**
       Изменил границы валидации, потому что в крупных городах бланки для паспортов могут печатать сверх квоты
       https://habr.com/ru/companies/hflabs/articles/478538/
       */
      return (
        possibleYear - passportYearsOffset <= passportDateYear && passportDateYear <= possibleYear + passportYearsOffset
      );
    });
  return isValid || context.createError({ path: context.path, message: 'Укажите корректный номер' });
};
